<template>
  <div id="payCenterRoot">
    <div id="payCenterContent"
      :style="{ 'width': $store.state.payCenterPageWidth, 'height': $store.state.payCenterPageHeight }">
      <div id="payCenterTitleDiv"
        :style="{ 'color': $store.state.payPageTitleColor, 'font-size': $store.state.titleFontSize }">支付中心
        <img style="width:25px;height:25px;position:absolute;right:5px" src="~assets/img/payCenter/close.png"
          @click="pageClose()" />
      </div>
      <div v-show="!hidePayInfoContent" style="display:flex;align-items:center;width: 70%;margin-top: 10px;">充值金额: {{ price }}元</div>
      <div v-show="!hidePayInfoContent"
        style="height:60%;width: 70%;display:flex;flex-direction:column;padding-left:20px;padding-right:20px;padding-top:10px;padding-bottom:10px;margin-top:5px;background-color: #F8F8F8;border-radius: 2px;">
        <span :style="{ 'color': $store.state.payPageTitleColor, 'font-size': $store.state.inputFontSize }">请选择支付方式</span>
        <div v-show="alipayShow" style="display:flex;flex-direction:row;margin-top: 10px;margin-left: 10px;align-items:center;"
          @click="alipay()">
          <img style="width:25px;height:25px;margin-right: 15px;" src="~assets/img/payCenter/alipay.png" />
          支付宝
        </div>
        <div v-show="wxpayShow" style="display:flex;flex-direction:row;margin-top: 20px;margin-left: 10px;align-items:center;"
          @click="wechat()">
          <img style="width:25px;height:25px;margin-right: 15px;" src="~assets/img/payCenter/wechat.png" />
          微信
        </div>
      </div>
      <div v-show="hidePayInfoContent"
        style="display:flex;flex-direction: column;justify-content:center;align-items:center;height:98%;width: 70%;font-size: x-small;color:#999">
        <div
          style="width: 80px;height:80px;border-radius:100px;background-color:#09bb07;display: flex;justify-content: center;align-items: center;color: white;">
          <img src="~assets/img/payCenter/hook.png" style="width: 60px;height:60px;">
        </div>
        <div
          style="display: flex;justify-content: center;align-items: center;color: black;font-size: large;margin-bottom: 5px;margin-top: 20px;">
          请确认
        </div>
        如您已完成支付，请返回游戏检查是否到账；如您支付遇到问题，请联系客服人员！
        <div
          style="display: none;width: 100%;height:35px;justify-content: center;align-items: center;color: black;font-size: large;margin-bottom: 5px;margin-top: 5px;background-color:#2EDFA3;">
          返回游戏
        </div>
      </div>

    </div>
    <Toast v-if="$store.state.showToast" />
    <Loading v-if="$store.state.showLoading" />
  </div>
</template>

<script>
import { request } from '@/network/request';
import getRequestParams from "@/signParams";
import utils from '@/utils';
import Toast from "views/payCenter/Toast.vue";
import Loading from "views/payCenter/Loading.vue";
export default {
  data() {
    return {
      price: "",
      gamecno: "",
      extradata: "",
      currentUrl: "",
      cno: "",
      clickType: -1,
      goPaySuccess: false,
      productName: "",
      
      productid: "",
      doingThing: false,
      alipayShow: false,
      wxpayShow: false,
      hidePayInfoContent: false,//点击支付之后，隐藏支付的页面


    }
  },
  components: {
    Toast, Loading
  },
  created: function () {

    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)

    // let productId = newValue['productid'];
    // 查询商品id
    let storeCommomParams = this.$store.state.commonParameters;

    this.productid = storeCommomParams['productid']
    let hadPayAction = localStorage.getItem(this.productid)
    console.log('hadPayAction',   hadPayAction);
    if (hadPayAction == 'true') {
    console.log('hadPayAction',   hadPayAction);
      this.hidePayInfoContent = true
    }

    // console.log(storeCommomParams);

    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] == 'true') {
      this.$store.commit("updateLoginPageSize");
      console.log("横屏");
      let scrrentWidth = storeCommomParams['screenWidth'];
      let screenHeight = storeCommomParams['screenHeight'];
      if (scrrentWidth && screenHeight) {
        let radio = parseInt(scrrentWidth) / parseInt(screenHeight);
        console.log(radio);
        // 小屏iphone, 375   667   比例是1.77 ，比1.8都小的直接把高度设置大一些
        if (radio < 1.8) {
          this.$store.commit("updateLoginPageSizeWithValue", { "screenHeight": "58vh" })
        }
      }
    } else {
      console.log("竖屏");
      let scrrentWidth = storeCommomParams['screenWidth'];
      let screenHeight = storeCommomParams['screenHeight'];
      if (scrrentWidth && screenHeight) {
        let radio = parseInt(screenHeight) / parseInt(scrrentWidth);
        console.log(radio);
        // 小屏iphone, 375   667   比例是1.77 ，比1.8都小的直接把高度设置大一些
        if (radio < 1.8) {
          this.$store.commit("updateLoginPageSizeWithValue", { "screenWidth": "85vw", "screenHeight": "32vh" })
        }
      }
    }


    this.gamecno = storeCommomParams['gamecno']
    this.extradata = storeCommomParams['extradata']
    // { "productid": storeCommomParams }
    let sendReqParams = getRequestParams({}, storeCommomParams);
    request({
      url: this.urls.PRODUCT,
      params: {
        data: sendReqParams
      },
    }).then(res => {
      console.log(res);
      let pattypes = JSON.parse(res.paytype)
      console.log(pattypes);
      pattypes.forEach(element => {
        if (element.type == 'alipay') {
          this.alipayShow = true
        }
        if (element.type == 'wxpay') {
          this.wxpayShow = true
        }
      });

      this.price = res['price'];
      this.productName = res['productname'];
    });

    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({}, storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    request({
      url: this.urls.REBATE_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    }).then(res => {
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid", { "rid": res["rid"], "phone": res["phone"] })
    })

  },
  methods: {
    pageClose() {
      // 关闭支付页面，通知SDK端去查订单状态，将结果发给渠道
      this.cno = localStorage.getItem("okGameCno")
      this.goPaySuccess = localStorage.getItem("okGameGoPaySuccess")
      let response = { 'cno': this.cno, "goPaySuccess": "" + this.goPaySuccess }
      localStorage.setItem("okGameCno", "")
      localStorage.setItem("okGameGoPaySuccess", false)
      localStorage.setItem(this.productid, false)
      this.sendToClient('closePayCenter?'.concat(JSON.stringify(response)))

    },
    alipay() {
      this.clickType = 1;
      this.order("alipay");
    },
    wechat() {
      this.clickType = 2;
      this.order("wxpay");
    },
    order(paytype) {
      let storeCommomParams = this.$store.state.commonParameters;
      let newParams = {
        'paytype': paytype,
        'extradata': this.extradata,
        'gamecno': this.gamecno,
      }
      console.log(storeCommomParams);
      console.log(newParams);
      // 查询商品id   
      let sendReqParams = getRequestParams(newParams, storeCommomParams);
      request({
        url: this.urls.ORDER,
        params: {
          data: sendReqParams
        },
      }).then(res => {
        console.log(res);
        var paydata = res['url'];

        let price = res['price']
        // 临时设置订单号，已经点击了下单，会重定向去支付软件，等关闭当前页面时需要拿到这两个值发给SDK端
        localStorage.setItem("okGameCno", res['cno'])
        localStorage.setItem("okGameGoPaySuccess", true)

        // 通知安卓端下单成功，需要上报给cps
        let response = { 'cno': res['cno'], "price": "" + parseInt(price), "payType": paytype }
        this.sendToClient('order?'.concat(JSON.stringify(response)))

        // this.cno = res['cno'];
        // this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "跳转链接 = "+paydata});
        // this.goPaySuccess = true;
        let platform = storeCommomParams["osPlatform"]
        // var u = navigator.userAgent;
        // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        // if (this.clickType == 1) {
        //   this.sendToClient('openUrl?'.concat(JSON.stringify({ "url": paydata})))
        // } else {
        //   if (platform == "android") {
        //     //android终端
        //     window.open(paydata, "_blank");

        //   } else {
        //     // this.$store.dispatch("updateCurrentUrl", paydata)
        //     //ios终端
        //     window.location.href = paydata;
        //   }
        // }
        if (platform == "android") {
            //android终端
            window.open(paydata, "_blank");

          } else {
            // this.$store.dispatch("updateCurrentUrl", paydata)
            //ios终端
            window.location.href = paydata;
          }
        
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "正在跳转支付，请稍等..." })
        localStorage.setItem(this.productid, true)
        setTimeout(() => {
          this.doingThing = false;
          this.hidePayInfoContent = true
        }, 2000)



        // window.open(paydata, "_blank");
        // 跳转支付后，关闭支付界面
        // this.$emit("setClosePayCenter");

      }).catch(error => {
        this.doingThing = false;
      });


    },

  },
}
</script>

<style>
body {
  padding-top: 0%;
  margin: 0%;
}

#payCenterRoot {
  width: 100vw;
  height: 100vh;
  /* background-color: transparent; */
  background-color: #0505056f;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

#payCenterContent {
  background-color: white;
  border-radius: 10px;
  /* padding-top: 10px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
}

#payCenterTitleDiv {
  position: relative;
  /* background-color: yellow; */
  width: 100%;
  padding-top: 5px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/payCenter/PayCenter.vue